import { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Styles from './TextViewMore.module.scss';

const TextViewMore = ({ text, more = 'View More', less = 'View Less', lines = 4 }) => {
  const [expanded, setExpanded] = useState(true);
  const handleToggle = () => {
    setExpanded((prevState) => !prevState);
  };

  return (
    <span className={classNames(Styles.description)}>
      <span
        className={classNames(Styles.clampedText)}
        style={{
          lineClamp: lines,
          WebkitLineClamp: lines,
          display: expanded ? '-webkit-box' : 'block',
        }}>
        {text}
      </span>
      <span onClick={handleToggle} className={Styles.viewMoreButton}>
        {expanded ? `${more}` : less}
      </span>
    </span>
  );
};

TextViewMore.propTypes = {
  text: PropTypes.string,
  lines: PropTypes.number,
  less: PropTypes.string,
  more: PropTypes.string,
};

export default TextViewMore;
